<template>
    <div class="question-input">
        <div class="form-group">
            <label for="ai-question-input" class="sr-only">Your Question</label>
            <div class="input-container">
                <input
                    id="ai-question-input"
                    ref="input"
                    v-model="localValue"
                    type="text"
                    class="form-control custom-input"
                    :class="{ 'is-invalid': hasError }"
                    placeholder="Type here"
                    :maxlength="characterLimit"
                    :disabled="isLoading"
                    @keydown.enter.ctrl="submitQuestion"
                    @keydown.enter.meta="submitQuestion"
                    @keydown.enter="submitQuestion"
                    @input="$emit('input', $event.target.value)"
                    aria-describedby="question-error"
                />
                <button
                    type="button"
                    class="send-button"
                    :class="{ 'disabled': !canSubmit }"
                    :disabled="!canSubmit || isLoading"
                    @click="submitQuestion"
                    title="Send"
                >
                    <i class="fas fa-arrow-up"></i>
                </button>
            </div>

            <!-- Error Message -->
            <div v-if="error" id="question-error" class="invalid-feedback d-block">
                {{ error }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'QuestionInput',

    props: {
        value: {
            type: String,
            default: ''
        },
        isLoading: {
            type: Boolean,
            default: false
        },
        characterLimit: {
            type: Number,
            default: 500
        },
        error: {
            type: String,
            default: ''
        }
    },

    computed: {
        localValue: {
            get() {
                return this.value
            },
            set(value) {
                this.$emit('input', value)
            }
        },


        hasError() {
            return !!this.error
        },

        canSubmit() {
            return !this.isLoading &&
                   this.value.length >= 2 &&
                   this.value.length <= this.characterLimit &&
                   this.value.trim().length >= 2
        }
    },

    mounted() {
        // Auto-focus on the input when component mounts
        this.$nextTick(() => {
            if (this.$refs.input) {
                this.$refs.input.focus()
            }
        })
    },

    methods: {
        submitQuestion() {
            if (this.canSubmit) {
                this.$emit('submit')
            }
        }
    }
}
</script>

<style scoped>
.question-input {
    /* Component styling */
}

.input-container {
    position: relative;
    display: flex;
    align-items: center;
    background: #f8f9fa;
    border: 1px solid #e9ecef;
    border-radius: 20px;
    padding: 2px;
    transition: all 0.2s ease;
}

.input-container:focus-within {
    border-color: #007bff;
    background: #fff;
}

.custom-input {
    flex: 1;
    border: none;
    background: transparent;
    outline: none;
    padding: 8px 12px;
    font-size: 0.9rem;
    color: #495057;
    border-radius: 20px;
    height: 32px;
}

.custom-input::placeholder {
    color: #6c757d;
    font-size: 0.85rem;
}

.custom-input:focus {
    border: none;
    box-shadow: none;
    background: transparent;
}

.send-button {
    width: 28px;
    height: 28px;
    border-radius: 50%;
    border: none;
    background: #007bff;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.2s ease;
    margin-right: 4px;
    flex-shrink: 0;
}

.send-button:hover:not(.disabled) {
    background: #0056b3;
    transform: scale(1.05);
}

.send-button.disabled {
    background: #6c757d;
    cursor: not-allowed;
    opacity: 0.6;
}

.send-button i {
    font-size: 12px;
}

@media (max-width: 576px) {
    .input-container {
        padding: 2px;
    }

    .custom-input {
        padding: 6px 10px;
        font-size: 0.85rem;
        height: 28px;
    }

    .send-button {
        width: 24px;
        height: 24px;
    }

    .send-button i {
        font-size: 10px;
    }
}
</style>



// WEBPACK FOOTER //
// src/Assets/components/AiAgents/CustomerService/components/QuestionInput.vue